import React from 'react'
import { connect } from 'react-redux'
import FileSaver from 'file-saver'
import * as actions from '../actions'

import Button from './Button'
import * as Content from '../reducers/Content'

const AddButton = (props) => <Button {...props} text="+" name="addPermission" />
const RemoveButton = (props) => (
  <Button {...props} text="&minus;" name="removePermission" />
)

const Title = (props) => (
  <div className="permissionsTitle">
    <span className="permissionsTitleIntro">Share</span>
    <span className="permissionsTitleIcon">{props.icon}</span>
    <span className="permissionsTitleTitle">{props.title}</span>
  </div>
)

const Permission = (props) => (
  <div className="permission">
    <RemoveButton onClick={props.onClickRemove} />
    <div className="permissionEmail">
      {props.recipient}
      {props.level === 'share' ? '' : ''}
    </div>
  </div>
)

function isValidEmail(email) {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(email)
}

function areValidEmails(emails) {
  return emails.length > 0 && !emails.find((email) => !isValidEmail(email))
}

class NewPermission extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      emails: '',
    }
  }

  onChange = (event) => {
    this.setState({ emails: event.currentTarget.value })
  }

  onClickAdd = () => {
    const emails = this.state.emails
      .split(/[\s,]+/)
      .map((email) => email.trim().toLowerCase())
    if (areValidEmails(emails)) {
      const contentId = this.props.contentId.split('-')
      this.props.firebase.addPermissions(contentId[1], emails)
      this.setState({ emails: '' })
    }
  }

  render() {
    return (
      <div className="newPermission">
        <AddButton onClick={this.onClickAdd} />
        <input
          type="text"
          value={this.state.emails}
          placeholder={this.props.placeholder}
          spellCheck="false"
          onChange={this.onChange}
        />
      </div>
    )
  }
}

const ExportButton = (props) => (
  <Button {...props} text="download" name="exportPermissions" />
)

const PermissionsBottomBar = (props) => (
  <div className="permissionsBottomBar">
    <ExportButton onClick={props.onClickExport} />
  </div>
)

class Permissions extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.onDocumentMouseDown)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onDocumentMouseDown)
  }

  onDocumentMouseDown = (event) => {
    const node = this.myRef.current
    if (node && !node.contains(event.target)) {
      this.props.onClickOutside(event.target.className)
    }
  }

  onClickRemovePermission = (contentId, recipient) => {
    this.props.firebase.removePermission(contentId, recipient)
  }

  onClickExport = () => {
    const fileName = `${this.props.firebase.userId().substring(0, 8)}-${
      this.props.contentId
    }-permissions.txt`
    const recipients = this.props.permissions.map((p) => p.recipient)
    const blob = new Blob([recipients.join('\n')], {
      type: 'text/plain;charset=utf-8',
    })
    FileSaver.saveAs(blob, fileName)
  }

  render() {
    const { contentId, icon, title, permissions } = this.props
    return (
      <div className="permissions" ref={this.myRef}>
        <Title icon={icon} title={title} />
        <NewPermission
          placeholder="recipient email"
          firebase={this.props.firebase}
          contentId={contentId}
        />
        <div>
          {permissions &&
            permissions.map((p) => (
              <Permission
                key={p.recipient}
                level={p.permission}
                recipient={p.recipient}
                onClickRemove={() =>
                  this.onClickRemovePermission(p.contentId, p.recipient)
                }
              />
            ))}
        </div>
        {permissions.length > 0 && (
          <PermissionsBottomBar onClickExport={this.onClickExport} />
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  const contentId = state.app.selectedContentId
  const content = state.ownContentCollection[contentId]
  const icon = Content.displayIcon(content, true)
  const title = Content.displayTitle(content, true)
  const permissions = state.app.permissions.filter(
    (p) => p.fullContentId === contentId,
  )

  return { permissions, icon, title, contentId }
}

const ConnectedPermissions = connect(mapStateToProps, actions)(Permissions)
export default ConnectedPermissions
